// Campus photo for /colleges/mercer-university: CC BY-SA 3.0, by Korea2006, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMercer_University_Central_Quadrangle.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/mercer-university/; credited under the photo.
const photo = {
    "slug": "mercer-university",
    "alt": "Lawns and walkways of the central quadrangle on Mercer University's Macon campus, with a brick clock tower building on the right",
    "src": "/colleges/mercer-university/campus-1600.webp",
    "srcSmall": "/colleges/mercer-university/campus-800.webp",
    "srcMid": "/colleges/mercer-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/mercer-university/og.jpg",
    "title": "Mercer University Central Quadrangle",
    "author": "Korea2006",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMercer_University_Central_Quadrangle.jpg",
    "read": "2026-10-01"
};

export default photo;
